"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageGalleryStyled = exports.DocCancelButton = exports.ModalDocDiv = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const QImageGallery_1 = __importDefault(require("../QuickenControls/QImageGallery"));
const ButtonsAll_1 = require("../StyledComponents/ButtonsAll");
const HomePageAll_1 = require("../StyledComponents/HomePageAll");
exports.ModalDocDiv = (0, styled_components_1.default)(HomePageAll_1.ModalDiv) `
  width: 75%;
  min-height: 75%;
  max-height: 93%;
  top: 41px;
  left: 12.5%;
`;
exports.DocCancelButton = (0, styled_components_1.default)(ButtonsAll_1.SmallWhiteButton) `
  margin-top: 0px;
`;
exports.ImageGalleryStyled = (0, styled_components_1.default)(QImageGallery_1.default) `
  background-color: ${({ theme }) => theme.palette.background.elevated};
`;
